import { CLIENT_VIEW_READ_ONLY_TOOLTIP } from "hooks/useViewAs";

/** Said over a setting the signed-in user may not change. */
export const ADMIN_ONLY_HINT =
  "Only authorized administrators can modify this setting.";

/** Said over Reset Password while the user has no saved email to send it to. */
export const RESET_NEEDS_EMAIL_HINT =
  "Please enter and save an email address to reset the password.";

/** Said over the password buttons for a user whose password is not theirs to
 * change. */
export const NO_PASSWORD_CHANGE_HINT =
  "You cannot change this user's password.";

interface LockState {
  /** Client View: the whole platform is read-only. */
  readOnly: boolean;
  /** The user is archived or scheduled for it, which locks them for everyone. */
  archived: boolean;
  /** The signed-in user may change this setting. */
  authorized: boolean;
}

/** What a switch or choice of the user forms says over it while it is off
 * because of who is looking; null when nothing is off, or when it is off for
 * everyone and the form says so elsewhere. */
export function lockHint({
  readOnly,
  archived,
  authorized,
}: LockState): string | null {
  if (readOnly) return CLIENT_VIEW_READ_ONLY_TOOLTIP;
  if (archived || authorized) return null;
  return ADMIN_ONLY_HINT;
}

/** Why Reset Password is off: the password is not the signed-in user's to change,
 * or there is no saved email to send the link to. */
export function resetPasswordHint({
  readOnly,
  canManagePasswords,
  hasEmail,
}: {
  readOnly: boolean;
  canManagePasswords: boolean;
  hasEmail: boolean;
}): string | null {
  if (readOnly) return CLIENT_VIEW_READ_ONLY_TOOLTIP;
  if (!canManagePasswords) return NO_PASSWORD_CHANGE_HINT;
  return hasEmail ? null : RESET_NEEDS_EMAIL_HINT;
}
